import React from 'react';
import Image from 'next/image';

function Quote() {
  return (
    <div className="mt-[2rem] flex flex-1 flex-col px-[1rem] sm:px-[2rem] md:ml-[2rem] md:mt-[5rem] md:gap-10">
      <blockquote className="mb-[1.3rem] max-w-[35rem] text-center text-[1.22rem] font-[500] text-white md:text-left md:text-[1.3rem]">
        “Switching to Thera for our payroll was one of the best decisions we made at Oceans.”
      </blockquote>
      <div className="flex gap-[1.5rem]">
        <div className="relative h-[6rem] w-[6rem] overflow-hidden rounded">
          <Image src="/images/thera-start/quote.png" alt="Ian Myers" fill className="rounded object-cover" />
        </div>
        <div className="space-y-[0.5rem]">
          <div className="font-[500] leading-tight text-white">Ian Myers</div>
          <div className="text-[0.875rem] font-[500] leading-tight text-white">Founder, Oceans</div>
        </div>
      </div>
    </div>
  );
}

export default Quote;
